import client from './api-client';

export const getConfiguracionForm22 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form22: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const actualizarTipoGastos = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/provison-gastos', file);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaTipoGastos: response.data};
        } else {
            return {respuestaTipoGastos: response.data};
        }
        
    } catch(error){
        throw error;
    }
}
export const postAnular = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/provison-gastos', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaAnular: response.data};
        } else {
            return {respuestaAnular: response.data};
        }
        
    } catch(error){
        throw error;
    }
}
export const getComboTipoGasto = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboTipoGasto: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboCobertura = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboCobertura: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboMonedas = async(query) => {
    try {
        
        const response = await client.get(`monedas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            
            return response.data.object
            
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaHistorialGastos = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado/provison-gastos/historial?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                grillaHistorialGastos: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getMontosInformados= async(query) => {
    try {
        
        const response = await client.get(`recobro/montos?q=${query}`);
       (response, "Respuesta Montos Informados");
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                montosInformados: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const verDocumento = async(query) => {
    try {
        
        const response = await client.verDocumento(`get-file?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return response.data;
        } else {
            return response.data;
        }

    } catch(error){
        throw error;
    }
}